import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=beb59db2&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=beb59db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb59db2",
  null
  
)

component.options.__file = "src/demo/packageMall/activity.vue"
export default component.exports